/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AtecoCodeModel } from '../../models/ateco-code-model';
import { AtecoCodeUpdateModel } from '../../models/ateco-code-update-model';

export interface PutApiAtecocodeV1Id$Plain$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: AtecoCodeUpdateModel
}

export function putApiAtecocodeV1Id$Plain(http: HttpClient, rootUrl: string, params: PutApiAtecocodeV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AtecoCodeModel>>> {
  const rb = new RequestBuilder(rootUrl, putApiAtecocodeV1Id$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AtecoCodeModel>>;
    })
  );
}

putApiAtecocodeV1Id$Plain.PATH = '/private/v1/ateco-codes/{id}';
